import { ONE_HOUR_IN_SECONDS } from '@ui/constants/time';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { TradePair } from '@ui/types/tradePair';
import { getDisplayFundingFeeRate } from '@ui/utils/trade/getDisplayFundingFeeRate';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

export const useBorrowRates = () => {
  const tradingPair = useTradingPair((v) => v.useTradingPair());

  return useLongShortFundingRatePerHour({ tradePair: tradingPair });
};

export const useLongShortFundingRatePerHour = ({
  tradePair,
}: {
  tradePair: TradePair;
}) => {
  const fundingFeeRate = tradePair.fundingFeeRate;
  const longHoldingFeeRate = tradePair.longHoldingFeeRate;
  const shortHoldingFeeRate = tradePair.shortHoldingFeeRate;

  return useMemo(() => {
    if (
      isNil(fundingFeeRate) ||
      isNil(longHoldingFeeRate) ||
      isNil(shortHoldingFeeRate)
    )
      return {};
    const rate = getDisplayFundingFeeRate({
      basicFundingRatePerSecond: fundingFeeRate,
      longHoldingFeeRatePerSecond: longHoldingFeeRate,
      shortHoldingFeeRatePerSecond: shortHoldingFeeRate,
    });
    const longFundingRatePerHour =
      rate?.displayLongFundingFeeRatePerSecond.multipliedBy(
        ONE_HOUR_IN_SECONDS,
      );

    const shortFundingRatePerHour =
      rate?.displayShortFundingFeeRatePerSecond.multipliedBy(
        ONE_HOUR_IN_SECONDS,
      );

    return {
      longFundingRatePerHour,
      shortFundingRatePerHour,
    };
  }, [fundingFeeRate, longHoldingFeeRate, shortHoldingFeeRate]);
};
